import { useEffect, useState } from "react";
/**
 * Hook to access Pendo agent instance
 * Returns the Pendo agent if available, null otherwise
 */
export const usePendo = () => {
    var _a;
    const [pendo, setPendo] = useState(typeof window !== "undefined" ? (_a = window.pendo) !== null && _a !== void 0 ? _a : null : null);
    useEffect(() => {
        if (typeof window === "undefined")
            return;
        // If Pendo is already available, set it immediately
        if (window.pendo) {
            setPendo(window.pendo);
            return;
        }
        // Poll for Pendo to become available
        let attempts = 0;
        const maxAttempts = 50; // 5 seconds max
        let timeoutId;
        const checkPendo = () => {
            if (window.pendo) {
                setPendo(window.pendo);
                return;
            }
            attempts++;
            if (attempts < maxAttempts) {
                timeoutId = setTimeout(checkPendo, 100);
            }
        };
        timeoutId = setTimeout(checkPendo, 100);
        // eslint-disable-next-line consistent-return
        return () => clearTimeout(timeoutId);
    }, []);
    return pendo;
};
